import { apiPromiseTypes } from 'redux/middleware/api-promise/action-types';

export const GET_BASKET_ELIGIBILITY = apiPromiseTypes(
  'basket-builder-experience-eligibility',
  'get',
);
export const GET_BASKET_SUGGESTIONS = apiPromiseTypes(
  'basket-builder-experience-suggestions',
  'get',
);
